<template>
  <v-badge
    bordered
    icon="mdi-test-tube"
    :value="stripeStatus.mode === 'test'"
    offset-y="10"
    offset-x="10"
    left
    color="secondary"
  >
    <v-card 
      id="app"
      align-content="center"
      class="pa=0 justify-center"
      width="300px"
      color="grey lighten-4"
      flat
      rounded
    >
      <v-card-text>
        <div id="card-element" />
        <div 
          id="card-errors"
          role="alert"
        />
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          :loading="busy"
          :disabled="!isReady || !complete || error" 
          elevation="0"
          color="primary"
          @click="pay"
        >
          {{ error ? 'Error' : 'pay' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-badge>
</template>

<script>
export default {
  name: 'StripeElement',
  props: {
    isReady: {
      type: Boolean,
    },
    billingDetails: {
      type: Object,
      default: ()=>{return {}}
    },
    items: {
      type: Array,
      default: ()=>[]
    },
    useClientAmount: {
      type: Boolean,
    },
    currency: {
      type: String,
      default: ()=>'usd'
    }
  },
  data () {
    return {
      stripeOptions: {
        style: {
          base: {
            backgroundColor: '#fff',
            fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
          },
        },
      },
      busy: false,
      stripe: '',
      elements: '',
      card: '',
      complete: false,
      processing: {
        show: false,
        text: 'Negotiating...',
      },
      error: false,
      stripeStatus: {}
    }
  },

  mounted() {
    this.loadStripeDependencies()
  },

  methods: {
    async loadStripeDependencies(){
      this.stripeStatus = await this.api.get('/stripe/market/status/') || {}
      this.includeStripe('js.stripe.com/v3/', function(){
          this.configureStripe();
      }.bind(this) );
    },

    configureStripe(){
        this.stripe = window.Stripe( this.stripeStatus.public_key );
        this.elements = this.stripe.elements();
        this.card = this.elements.create('card', this.stripeOptions);
        this.card.mount('#card-element');
        this.card.on('change', evt=>{
          if (this.complete !== evt.complete) {
            this.complete = evt.complete
          }
        })
    },
    includeStripe( URL, callback ){
        let documentTag = document, tag = 'script',
            object = documentTag.createElement(tag),
            scriptTag = documentTag.getElementsByTagName(tag)[0];
        object.src = '//' + URL;
        if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
        scriptTag.parentNode.insertBefore(object, scriptTag);
    },

    async pay(){
      this.busy = true
      let clientPricing = this.items.reduce((a, c)=>{
        if (c && c.productID) {
          a[c.productID] = c.amount * 100
        }
        return a
      }, {})
      this.$store.commit('market/invoice', null)
      let data = await this.api.post('/stripe/payment_intent', {
        items: this.items,
        shipping: this.shipping,
        clientPricing: this.useClientAmount ? clientPricing : false,
        eval: true,
        currency: this.currency && this.currency.toLowerCase()
      })

      if (data.client_secret) {
        this.stripe.confirmCardPayment(data.client_secret, {
          payment_method: {
            card: this.card,
            billing_details: this.billingDetails
          }
        }).then(r=>{
          if (r.error) {
            console.error('Error returned from stripe.confirmCardPayment',  r.error.message);
          } else {
            if (r.paymentIntent.status === 'succeeded') {
              this.$store.commit('market/invoice', data.invoice)
              this.$emit('success')
            }
          }
        }).catch(err=>{
          this.error = true
          console.error('Unknown error occured during stripe.confirmCardPayment',  err);
        }).then(()=>{
          this.busy = false
        })
      } else {
        this.busy = false
        this.error = true
        console.error('Error while seeking payment intent:', data)
      }
    }
    
  }
}
</script>

<style scoped>
  .theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
    background-color: rgba(167, 167, 167, 0.687) !important;
  }
</style>